<ion-header [translucent]="true" class="flex flex-col" >
    <ion-toolbar color="secondary" >
        <div slot="start" class="flex flex-row items-center gap-4" [ngClass]="{'native-header': isNative}">
            <ion-menu-button color="primary" menu="nav"></ion-menu-button>
            <a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
                HOME
            </a>
            <app-header-cart-status></app-header-cart-status>
        </div>

        <ion-title class="text-center">
            <ng-content></ng-content>
        </ion-title>

        <ion-buttons slot="end" class="invisible xs:visible">
            <app-auth-status></app-auth-status>
        </ion-buttons>

        @if (showLoading()) {
            <ion-progress-bar type="indeterminate"></ion-progress-bar>
        }
    </ion-toolbar>
</ion-header>



